export default __webpack_public_path__ + "static/media/web.a7222d00.png";